'use-strict'

import { App } from "./utilities/App";

import { addToCartActions } from "./components/add-to-cart";
import { alertActions, cookiesNotifyActions } from "./components/alerts";
import { faqActions } from "./components/faq";
import { navbarActions, rollUpNavbar, showNavbarCart } from "./components/nav";
import { parallaxEvent } from "./components/parallax";
import { quantityCounterActions } from "./components/quantity-counter";
import { onToggleProductsGridSlider, productsGridActions, productsGridInit } from "./components/products-grid";

$(document).ready(function () {
	
	App.init( () => {

		addToCartActions();
		quantityCounterActions();
		
		/* START NAVBAR */
		navbarActions();
		rollUpNavbar();
		/* END NAVBAR */
		
		/* START ALERTS */
		alertActions();
		cookiesNotifyActions();
		/* END ALERTS */
		
		/* START PRODUCTS GROUP FUNCTIONS */
		productsGridActions();
		parallaxEvent();
		faqActions();

		productsGroupPageInit();
		/* END PRODUCTS GROUP FUNCTIONS */
		
	} );

});

$(window).scroll(function () {
	
	/* START NAVBAR */
	rollUpNavbar();
	/* END NAVBAR */

	/* START PRODUCTS GROUP FUNCTIONS */
	parallaxEvent();
	/* END PRODUCTS GROUP FUNCTIONS */
	
});

$(window).resize(function () {
	
	/* START PRODUCTS GROUP FUNCTIONS */
	onToggleProductsGridSlider();
	parallaxEvent();
	/* END PRODUCTS GROUP FUNCTIONS */
	
});

$('[js-customers-opinions]').slick({
	autoplay: true,
	autoplaySpeed: 8000,
	pauseOnDotsHover: true,
	swipeToSlide: true,
	prevArrow: $('[js-customers-opinions-arrow-left]'),
	nextArrow: $('[js-customers-opinions-arrow-right]'),
	dots: true,
	dotsClass: 'customers-opinions__pagination',
	appendDots: '.customers-opinions__wrapper',
});

$('[js-products-list-element]').each(function() {

	$(this).find('[js-products-list-gallery-wrapper]').slick({
		autoplay: true,
		autoplaySpeed: 3000,
		swipeToSlide: true,
		arrows: false,
		dots: true,
		dotsClass: 'products-list__gallery-dots',
		appendDots: $(this).find('[js-products-list-gallery]'),
		variableWidth: true,
		centerMode: true,
		centerPadding: '0px',
	});
	
});

function productsGroupPageInit() {

	productsGridInit();
	
}